import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Grid, Button, Typography } from "@mui/material";
import { surface } from "../../../../theme/muiTheme";

// Brought outside of InfoModal to allow testing
const showDiagnostics = (diagnostics, idx, t) => {
  const values = diagnostics && Object.keys(diagnostics);
  if (values && values.length > 0) {
    return values.map((val, index) => (
      <Grid container
        key={`ReportDiagnosticColumn${idx}${index}`}
        sx={{ my: 1 }}
        role="row"
      >
        <Grid>{val}</Grid>
        <Grid size={{ xs: 4, sm: 5, md: 6, xl: 7 }}>
          {Math.round(diagnostics[val].DiagnosticsValue * 1000) / 1000}{" "}
          {diagnostics[val].DiagnosticsUnit}
        </Grid>
      </Grid>
    ));
  }
  return <div>{t("No Diagnostics")}</div>;
};

const showAlarms = (alarms, idx, t) => {
  const values = alarms && Object.keys(alarms);
  if (values && values.length > 0) {
    return values.map((val, index) => (
      <Grid container
        sx={{ py: 1, my: 0.5 }}
        key={`ReportAlarmColumn${idx}${index}`}
        style={{ backgroundColor: surface.panel }}
        role="row"
      >
        <Grid size={12} style={{ justifyContent: "center", display: "flex" }}>
          {alarms[val]}
        </Grid>
      </Grid>
    ));
  } else {
    return <Typography sx={{ color: "text.secondary", py: 1 }}>{t("No Alarms")}</Typography>;
  }
};

const InfoModal = ({ values, show, onHide, infoIndex, t, setInfoIndex }) => {

  const closeAutoZeroModal = () => {
    onHide();
    setInfoIndex(-1);
  }

  return (
    <Dialog
      open={show}
      onClose={closeAutoZeroModal}
      maxWidth="lg"
      fullWidth
      id="infoModal"
    >
      <DialogTitle>Info</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <h4>{t("Diagnostics")}</h4>
          {values.length > 0 && values.map(
            (val, idx) =>
              idx === infoIndex && (
                <Box key={`${val.diagnostics}${idx}`} sx={{ mt: 0.5 }}>
                  {showDiagnostics(val.Diagnostics, idx, t)}
                </Box>
              )
          )}
        </Box>
        <Box sx={{ mb: 2 }}>
          <h4>{t("Alarms")}</h4>
          {values.length > 0 && values.map(
            (val, idx) =>
              idx === infoIndex && (
                <Box key={`${val.ActiveAlarms}${idx}`} sx={{ mt: 0.5 }}>
                  {showAlarms(val.ActiveAlarms, idx, t)}
                </Box>
              )
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button size="large" onClick={closeAutoZeroModal} variant="contained" color="success">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoModal;
// Export for testing
export { showDiagnostics, showAlarms };
